<template>
    <data-dialog
        :dialog-title="userDialog.title"
        :closeOnClickModal = 'false'
        :is-visible="userDialog.formVisible"
        ref="roleDialog"
        @dgVerifyDeal="dgVerifyDeal('roleDialog','userDialog')"
        @dgCancelDeal='cancel'
        @dgConfirmDeal="save"

    >
      <div slot="dialogFrom">
      <el-form ref="userDialog" :model="userDialog.data" :rules="rules" label-width="80px" label-position="top" class="commonForm">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="序号" prop="no" style="width: 70%;">
                        <el-input v-model="userDialog.data.no" controls-position="right" :min="0" :maxlength="10" :pattern="pattern" @input="handleInput"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" >
                    <el-form-item label="名称" prop="name" style="width: 70%;">
                        <el-input v-model="userDialog.data.name"  placeholder="请输入名称" maxlength="30" />
                    </el-form-item>
                </el-col>
            </el-row>
              <el-form-item label="菜单权限">
                <div style="max-height: 50vh">
                  <div class="qxAll">
                    <el-checkbox v-model="checkAll" @change="handleCheckedTreeNodeAll()">所有权限</el-checkbox>
                  </div>
                  <div>
                      <div v-for="(item,index) in userDialog.data.list" :key="index">
                        <div class="qx">
                          <!-- 左侧父节点 -->
                          <div>
                            <div v-if="item.leaf" class="qxF" >
                              <el-checkbox v-model="item.hasCheck" :data-a="selectCheck" @change="selectChange(item)" style="height: 40px;line-height: 40px;">
                                <span>{{ item.label }}</span>
                              </el-checkbox>
                            </div>
                            <div v-else style="width: 120px;padding-left: 10px;">
                              <el-checkbox v-model="item.hasCheck" :indeterminate="item.isIndeterminate" @change="fjdChange(item)" :data-a="selectCheck" class="check">
                                <span>{{ item.label }}</span>
                              </el-checkbox>
                            </div>
                          </div>
                        <!-- 右侧子节点 -->
                        <div>
                          <div v-for="c in item.children" :key="c.nodeId+'1'" class="qxZ">
                            <el-checkbox v-model="c.hasCheck" @change="zjdChange(c,item)" :indeterminate="c.isIndeterminate" :data-a="selectCheck" class="check">
                              <span>{{ c.label }}</span>
                            </el-checkbox>
                          </div>
                        </div>
                        <div style="width: 100%">
                          <div v-for="c in item.children" :key="c.nodeId+'1'" >
                            <el-row v-if="c.children.length > 0" >
                              <el-col :span="6" v-for="(x,index) in c.children" :key="x.nodeId+'2'" class="qxS">
                                <el-checkbox v-model="c.children[index].hasCheck" @change="sjdChange(c.children[index],c,item)" :data-a="selectCheck" class="check">
                                  <span>{{ x.label }}</span>
                                </el-checkbox>
                              </el-col>
                            </el-row>
                            <div v-else>
                              <div style="height: 40px;border-bottom: 2px solid #f0f5fd;border-left: 2px solid #f0f5fd">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                  </div>
                </div>
              </el-form-item>
        </el-form>
      </div>
    </data-dialog>
</template>
<script>
    import DataDialog from "@/components/tableGather/dataDialog.vue";
    export default {
        name: "roleOpen",
      components:{
        DataDialog
      },
        data(){
            return{
              pattern: /^\d{0,10}$/,
              // userDialog:{
              // },
              //授权
              checkAll: false,
              allCheck: true,
              hasCheck: true,
              grandHasCheck: true,
              selectCheck:true,
              isIndeterminate: true,
              defaultProps: {
                children: "children",
                label: "label"
              },
              rules: {
                no: [
                  { required: true, message: '序号不能为空'},
                ],
                name: [
                  {required: true, message: '请输入名称', trigger: 'blur'},
                  { min: 2, message: '名称最少为2位'},
                  { max: 30, message: '名称最大为为30位'},

                ],
              }
            }
        },
        methods:{
          handleInput(){
            // 使用正则表达式检查输入的值是否为数字
            this.userDialog.data.no = this.userDialog.data.no.replace(/\D/g, '');
            // 如果输入超过10个字符，截取前10个字符
            if (this.userDialog.data.no.length > 9) {
              this.userDialog.data.no = this.userDialog.data.no.slice(0, 9);
              }
          },
          cancel(){
            this.$emit("reset")
            // this.dialog.formVisible = false;
            //重置表单值
            // this.$refs['userDialog'].resetFields();
            if (this.userDialog.formVisible) {
              this.$refs.userDialog.clearValidate();
              this.$refs.userDialog.resetFields();
              this.userDialog.formVisible = false;
            }
              this.checkAll= false
          },
          dgVerifyDeal(dgRef, frRef) {
            this.$refs[frRef].validate((valid) => {
              if (valid) {
                this.$refs[dgRef].isShowPop(true);
              } else {
                this.$refs[dgRef].isShowPop(false);
              }
            });
          },
          save(){
            this.$refs['userDialog'].validate((valid) => {
              let xz = [];
              for (let i = 0; i < this.userDialog.data.list.length; i++) {
                const fu = this.userDialog.data.list[i];
                if (fu.leaf) {
                  if (fu.hasCheck) {
                    xz.push(fu.authbit);
                  }
                }else{
                  if (fu.hasCheck) {
                    xz.push(fu.authbit);
                  }
                  for (let a = 0; a < fu.children.length; a++) {
                    const zi = fu.children[a];
                    if (zi.hasCheck) {
                      xz.push(zi.authbit);
                    }
                    for(let b = 0 ; b < zi.children.length;b++){
                      const sun = zi.children[b];
                      if (sun.hasCheck) {
                        xz.push(sun.authbit);
                      }
                    }
                  }
                }
              }
              if (valid) {
                const data = {
                  id:this.userDialog.data.id,
                  name:this.userDialog.data.name,
                  no:this.userDialog.data.no,
                  authstrList:xz,
                }
                if(this.userDialog.title === '角色信息'){
                  this.request.put("/rm-srole/v1", data).then(res => {
                    if (res.ok) {
                      this.userDialog.formVisible = false
                      this.$emit("reset")
                      this.$message.success("修改角色完成！")
                      this.cancel();
                    }
                  })
                }else{
                  this.request.post("/rm-srole/v1", data).then(res => {
                    if (res.ok) {
                      this.userDialog.formVisible = false
                      this.$emit("reset")
                      this.$message.success("添加角色完成！")
                      this.cancel();
                    }
                  })
                }

              } else {
                return false;
              }
            });
          },
          // 树权限（全选/全不选）
          handleCheckedTreeNodeAll(value) {
            if (this.checkAll) {
              for (let i = 0; i < this.userDialog.data.list.length; i++) {
                this.userDialog.data.list[i].hasCheck = true;
                if (!this.userDialog.data.list[i].leaf) {
                  this.userDialog.data.list[i].allCheck = false;
                  this.userDialog.data.list[i].isIndeterminate = false;
                  for (let a = 0; a < this.userDialog.data.list[i].children.length; a++) {
                    this.userDialog.data.list[i].children[a].hasCheck = true;
                    this.userDialog.data.list[i].children[a].isIndeterminate = false;
                    for(let j = 0 ;j<this.userDialog.data.list[i].children[a].children.length;j++){
                      this.userDialog.data.list[i].children[a].children[j].hasCheck = true;
                    }
                  }
                }
              }
            }else{
              for (let i = 0; i < this.userDialog.data.list.length; i++) {
                this.userDialog.data.list[i].hasCheck = false;
                if (!this.userDialog.data.list[i].leaf) {
                  this.userDialog.data.list[i].allCheck = false;
                  this.userDialog.data.list[i].isIndeterminate = false;
                  for (let a = 0; a < this.userDialog.data.list[i].children.length; a++) {
                    this.userDialog.data.list[i].children[a].hasCheck = false;
                    this.userDialog.data.list[i].children[a].isIndeterminate = false;
                    for(let j = 0 ;j<this.userDialog.data.list[i].children[a].children.length;j++){
                      this.userDialog.data.list[i].children[a].children[j].hasCheck = false;
                    }
                  }
                }
              }
            }
          },
          //值变动
          selectChange(){
            this.selectCheck = !this.selectCheck;
          },
          // 父节点选择
          fjdChange(item){
            this.selectCheck = !this.selectCheck;
            item.isIndeterminate = false;
            if (item.hasCheck) {
              item.allCheck = false;
              for (let i = 0; i < item.children.length; i++) {
                item.children[i].hasCheck = true;
                this.hasCheck = true;
                for(let j =0; j< item.children[i].children.length;j++){
                  item.children[i].children[j].hasCheck = true;
                }
              }

            }else{
              item.allCheck = false;
              for (let i = 0; i < item.children.length; i++) {
                item.children[i].hasCheck = false;
                for(let j =0; j< item.children[i].children.length;j++){
                  item.children[i].children[j].hasCheck = false;
                }
              }
            }
          },
          // 子节点选择
          zjdChange(val,item){
            this.selectCheck = !this.selectCheck;
            //子组件与父组件联动
            let checklenth = 0
            for(let i of item.children){
              if(i.hasCheck){
                checklenth++
              }
            }
            item.hasCheck = checklenth === item.children.length
            item.isIndeterminate = checklenth > 0 && checklenth < item.children.length;
            //子组件与孙组件联动
            for(let i of val.children){
              i.hasCheck = val.hasCheck
            }
            val.isIndeterminate = false
          },
          // 孙节点选择
          sjdChange(val,c,item){
            this.selectCheck = !this.selectCheck;
            //特殊情况（如有三级权限必有查询查询）
            if(val.label !== '查询'){
              for(let i of c.children){
                if(i.label === '查询' && val.hasCheck === true){
                  i.hasCheck = true
                }
              }
            }
            //孙节点与子组件联动
            let checklenth = 0
            for(let i of c.children){
              if(i.hasCheck){
                checklenth++
              }
            }
            c.hasCheck = checklenth === c.children.length
            c.isIndeterminate = checklenth > 0 && checklenth < c.children.length;
            //孙节点与父组件联动
            let sunlenth = 0
            let sunchecklenth = 0
            for(let i of item.children){
              sunlenth++
              if(i.hasCheck){
                sunchecklenth++
              }
              for(let ii of i.children){
                sunlenth++
                if(ii.hasCheck){
                  sunchecklenth++
                }
              }
            }
            item.hasCheck = sunlenth === sunchecklenth
            item.isIndeterminate = sunchecklenth > 0 && sunchecklenth < sunlenth;
          },

        },
        props: {
          userDialog: {}
        }
    }
</script>
<style scoped>
.commonForm {
  padding-top: 4vh;
  padding-left: 6vh;
}
.qxAll{
  background-color: #f2f3f5;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
}
.qx{
  display: flex;
  justify-content: flex-start;
  align-items:center;
  border: 2px solid #f0f5fd;
  margin-bottom: -2px;
}
.qxF{
  width: 120px;
  /*border-right: 2px solid #f0f5fd;*/
  padding-left: 10px;
}

.qxZ{
  width: 120px;
  border-left: 2px solid #f0f5fd;
  border-right: 2px solid #f0f5fd;
  border-bottom: 2px solid #f0f5fd;
  padding-left: 20px;
}
.qxS{
  //width: 25%;
  padding:0px 20px;
  border-left: 2px solid #f0f5fd;
  border-right: 2px solid #f0f5fd;
  border-bottom: 2px solid #f0f5fd;
}

.qxM{
  padding-left: 20px;
  border: 2px solid #f0f5fd;
  width: 50px;
}

.qxN{
  padding-left: 20px;
  border-right: 2px solid #f0f5fd;
}

/deep/ .el-select{
  width: 70%;
}
</style>
